import * as actions from './constants';

/**
 * apply user information when user has logged in successfully
 * @param {object} request
 */
export function getMessages(messages) {
  return {
    type: actions.GET_MESSAGES,
    messages,
  };
}

export function getAlerts(alerts) {
  return {
    type: actions.GET_ALERTS,
    alerts,
  };
}

export function messageCleanup() {
  return {
    type: actions.GET_MESSAGES_CLEANUP,
  };
}
